import type { RootState } from '/business/shared/state/store';
/**
 * Get the version of the state loaded
 */

export default (state: RootState) => {
  return state.basket?.stateAppId;
};
